export const Default = {
    0: '否',
    1: '是',
};

export const MedicineType = {
    Research_drugs: '药物',
    Technology: '技术类（如细胞技术）',
    Medical_instruments: '医疗器械',
    Vaccines: '疫苗',
    Diagnostic_reagent: '诊断试剂',
    Others: '其他',
};

export const ContractNature = {
    FIRST_CONTRACT: '首次合同',
    SUPPLEMENT_CONTRACT: '补充合同',
    RENEW_CONTRACT: '续签合同',
    TERMINATION_CONTRACT: '终止合同',
    TERMINATION_LETTER: '终止函',
};

export const GlobalType = {
    Global_Multicenter: '全球多中心',
    Internal_Multicenter: '国内多中心',
    Internal_Single: '国内单中心管理(区域负责)',
    Not_Applicable: '不适用',
};

export const JdeApplyStatus = {
    ASSISTANT_APPROVAL: '待助理审批',//CRM合同生成的JDE建号申请 初始状态
    ASSISTANT_APPROVAL_DISAGREE: '助理审批不通过',
    VP_APPROVAL_ADVANCE_DUTY: '待VP审批提前上岗',
    ADVANCE_DUTY_DISAGREE: '提前上岗审批不通过',
    CTA_CREATE_INVESTIGATION: '待CTA新建项目',
    INVESTIGATION_CREATING: '项目创建中',//自动创建项目异步处理中,成功变更为待FIN审批JDE号,失败回退为待CTA新建项目
    CTA_REFUSED_CREATE_INVESTIGATION: '创建项目被拒绝',
    FIN_APPROVAL_JDE: '待FIN审批JDE号',
    JDE_DISTRIBUTION: 'JDE号已发放',
    JDE_REJECT_DISTRIBUTION: 'JDE号发放被拒绝',
    JDE_DISAGREE_DISTRIBUTION: 'JDE号审批不通过',
    PM_APPROVAL_CONTRACT_MONEY: '待PM审核合同金额',
    PM_DISAGREE_APPROVAL_CONTRACT_MONEY: 'PM审核合同金额不通过',
    CTA_APPROVAL_CONTRACT_MONEY: '待CTA审核合同金额',
    CTA_DISAGREE_APPROVAL_CONTRACT_MONEY: 'CTA审核合同金额不通过',
    FIN_APPROVAL_CONTRACT_MONEY: '待FIN审核合同金额',
    FIN_AGREE_APPROVAL_CONTRACT_MONEY: 'FIN审核合同金额通过',
    FIN_DISAGREE_APPROVAL_CONTRACT_MONEY: 'FIN审核合同金额不通过',
    PM_APPROVAL_CLOSE_JDE: '待PM审批关闭申请',
    PM_DISAGREE_CLOSE_JDE: 'PM审批关闭申请不通过',
    BO_APPROVAL_CLOSE_JDE: '待BO审批关闭申请',
    BO_DISAGREE_CLOSE_JDE: 'BO审批关闭申请不通过',
    VP_APPROVAL_CLOSE_JDE: '待VP审批关闭申请',
    VP_DISAGREE_CLOSE_JDE: 'VP审批关闭申请不通过',
    JDE_CLOSED: 'JDE建号申请已关闭',
    PM_APPROVAL_NO_SIGNED_CLOSE_JDE:'待PM审批未签署合同关闭申请',
    PM_DISAGREE_NO_SIGNED_CLOSE_JDE:'PM审批未签署合同关闭申请不通过',
    FIN_APPROVAL_NO_SIGNED_CLOSE_JDE:'待BO审批未签署合同关闭申请',
    FIN_DISAGREE_NO_SIGNED_CLOSE_JDE:'BO审批未签署合同关闭申请不通过',
    NO_SIGNED_JDE_CLOSED:'未签署合同申请已关闭',
    PRINCIPAL_CREATE_INVESTIGATION:'待负责人审批新建项目',
    PRINCIPAL_DISAGREE_CREATE_INVESTIGATION:'负责人审批新建项目不通过',
    CTA_BACK_CREATE_INVESTIGATION:'打回创建项目',
};

export const maxLayout = {
    labelCol: {
        sm: { span: 6, pull: 1 },
        md: { span: 6, pull: 1 },
    },
    wrapperCol: {
        sm: { span: 18, pull: 1 },
        md: { span: 18, pull: 1 },
    },
};

export const commonLayout = {
    labelCol: {
        sm: { span: 12, pull: 2 },
        md: { span: 12, pull: 2 },
    },
    wrapperCol: {
        sm: { span: 12, pull: 2 },
        md: { span: 12, pull: 2 },
    },
};


// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/constants.js